import { I18n } from "@assets/strings";
import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useSuggestedArticles } from "@domain/lms/article/hooks";
import { ArrowNavigator } from "@ui/components/arrowNavigator";
import { ArticleThumbnail } from "@ui/components/article/articleThumbnail";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Tertiary } from "@ui/components/containers/textBlocks";
import { Row } from "@ui/components/layout";
import { gap } from "@ui/styles/utils";

type ArticleSuggestCardProps = React.HTMLAttributes<HTMLDivElement>;

export const ArticleSuggestCard: React.FC<ArticleSuggestCardProps> = ({ ...htmlProps }) => {
	const currentProfile = useCurrentProfile();
	const userCategories = currentProfile?.categories;
	const { result: articles, loading } = useSuggestedArticles(10, userCategories ? userCategories : undefined);
	const [currentIndex, setIndex] = useState(0);
	const doubleLineArticles = [];
	if (articles && articles.length > 0) {
		const articleLength = articles.length;
		let i = 0;
		while (i < articleLength) {
			doubleLineArticles.push(i + 1 < articleLength ? [articles[i], articles[i + 1]] : [articles[i]]);
			i = i + 2;
		}
	}

	return !loading && doubleLineArticles && doubleLineArticles.length > 0 ? (
		<Container {...htmlProps}>
			<Row gap={10} align="center" justify="space-between">
				<PrimaryMedium>{I18n.t("article.suggest.title")}</PrimaryMedium>
				{doubleLineArticles.length > 1 && (
					<StyledArrowNavigator
						small
						previous={() => setIndex((i) => (i - 1 + doubleLineArticles.length) % doubleLineArticles.length)}
						next={() => setIndex((i) => (i + 1) % doubleLineArticles.length)}
					/>
				)}
			</Row>
			{loading ? (
				<ClipLoader />
			) : doubleLineArticles && doubleLineArticles.length > 0 ? (
				<>
					<ArticleThumbnail
						forFeed
						key={doubleLineArticles[currentIndex][0].id}
						article={doubleLineArticles[currentIndex][0]}
					/>
					{doubleLineArticles[currentIndex][1] && (
						<ArticleThumbnail
							forFeed
							key={doubleLineArticles[currentIndex][1].id}
							article={doubleLineArticles[currentIndex][1]}
						/>
					)}
				</>
			) : (
				<Tertiary>{I18n.t("article.suggest.no_results")}</Tertiary>
			)}
		</Container>
	) : (
		<></>
	);
};

const Container = styled.div`
	${gap(16)};
`;

const StyledArrowNavigator = styled(ArrowNavigator)`
	width: 70px;
`;
